module.exports = __webpack_public_path__ + "/static/assets/b05737738e9f96ee6ca8791a9a0ba2c3.png";